'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = template;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../style/index');

var _index2 = _interopRequireDefault(_index);

var _reactTransitionGroup = require('react-transition-group');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function template() {
    var classList = this.compileStyle(_index2.default),
        hintContent = null;

    if (!this.state.hidden) {
        hintContent = _react2.default.createElement(
            _reactTransitionGroup.CSSTransition,
            {
                component: 'div',
                classNames: classList.animation,
                timeout: 450,
                key: 'content'
            },
            _react2.default.createElement(
                'div',
                { className: classList.animation + ' ' + classList.wrapper, ref: this._hintRef.bind(this) },
                _react2.default.createElement(
                    'div',
                    { className: classList.label + ' ' + (this.props.labelClassName || '') },
                    this.props.label
                ),
                _react2.default.createElement('div', { className: classList.triangle })
            )
        );
    }

    return _react2.default.createElement(this.props.component, {
        className: classList.root + ' ' + (this.props.className || ''),
        onMouseEnter: this._handleMouseEnter.bind(this),
        onMouseLeave: this._handleMouseLeave.bind(this),
        ref: this._rootRef.bind(this)
    }, _react2.default.createElement(
        _reactTransitionGroup.TransitionGroup,
        null,
        hintContent
    ), this.props.children);
}